export interface AppShellLocationParts {
  pathname: string;
  search?: string;
  hash?: string;
}

export function getEventsNavTarget(location: AppShellLocationParts): string {
  if (location.pathname === '/events') {
    return `/events${location.search ?? ''}${location.hash ?? ''}`;
  }
  return '/events';
}
